(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Collaboration', Collaboration);

    Collaboration.$inject = ['$resource'];

    function Collaboration ($resource) {
        var resourceUrl =  'api/collaborations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
